<script setup lang="ts">
const props = defineProps({
  notification: {
    type: Object,
    default: () => {}
  }
})
const { t } = useI18n()
const messageParts = props.notification.message.split(' : ')
const title = messageParts[0]
const message = messageParts[1]
</script>
<template>
  <div>
    <p style="white-space: normal">
      <strong>{{ t(title) ?? '' }}</strong>
    </p>
    <p>{{ t(message ?? '') }}</p>
    <p v-if="notification.url" class="w-100 whitespace-normal mb-0" style="white-space: normal">
      <router-link :to="notification.url" color="red">
        {{ t('More info') }}
      </router-link>
    </p>
  </div>
</template>
